export enum BankValidatorTypes {
  IFSC_CODE = "ifscCode",
  ACH_CODE = "achCode",
  IBAN_CODE = "ibanCode",
  BSB_CODE = "bsbCode",
  SORT_CODE = "sortCode",
}
